export default __webpack_public_path__ + "static/media/pohled-z-kuchyne.25a1da50.jpeg";